/* global axios */
import ApiClient from './ApiClient';

class ContactImportsAPI extends ApiClient {
  constructor() {
    super('contact_imports', { accountScoped: true });
  }

  getTemplate() {
    return axios.get(`${this.url}/template`, {
      responseType: 'blob',
    });
  }
}

export default new ContactImportsAPI();
